import { render, staticRenderFns } from "./QRCodeGenerator.vue?vue&type=template&id=5b5ec952&scoped=true"
import script from "./QRCodeGenerator.vue?vue&type=script&lang=js"
export * from "./QRCodeGenerator.vue?vue&type=script&lang=js"
import style0 from "./QRCodeGenerator.vue?vue&type=style&index=0&id=5b5ec952&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5ec952",
  null
  
)

export default component.exports